import SubscribeToDetailTaskListRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/task/request/SubscribeToDetailTaskListRequest";
import UnSubscribeToDetailTaskListRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/task/request/UnSubscribeToDetailTaskListRequest";

export const mapSubscribeTaskListRequest = (tasks: Array<number>) =>
  new SubscribeToDetailTaskListRequest({
    TaskIds: tasks,
  });

export const mapUnSubscribeTaskListRequest = (tasks: Array<number>) =>
  new UnSubscribeToDetailTaskListRequest({
    TaskIds: tasks,
  });
